import React, { useRef } from "react";

const ProgressBarComponent = ({ isYear, Percentage = 0 }) => {

  const count = isYear
  ? Percentage?.year * 10 + Percentage?.month || 0 // Destructure and handle potential undefined values
  : Percentage;

  const content = (
    <div style={myProgressStyle}>
      <div style={myBarStyle(count)}>
        {count >= 5 ? (isYear ? `${Percentage?.year}y ${Percentage?.month}m` : `${count}%`) : null}
      </div>
      {count < 5 ? (isYear ? `${Percentage?.year}y ${Percentage?.month}m` : `${count}%`) : null}

      {isYear && (
        <>
          <div style={labelStyle}>0</div>
          <div style={rightLabelStyle}>10 year</div>
        </>
      )}
    </div>
  );

  return content;
 
 
};

export default ProgressBarComponent;

const myProgressStyle = {
  display: "flex",
  alignItems: "center",
  gap: "3px",
  marginTop: "8px",
  position: "relative",
  width: "100%",
  backgroundColor: "#eeeeee",
};

const myBarStyle = (count) => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // width: `${count}%`,
    width : `${Math.min(count, 100)}%`,
    transition : 'width 2s',
    height: "30px",
    backgroundColor: "#dc002d",
    color: "white",
    position: "relative",
  };
};

const labelStyle = {
  position: "absolute",
  bottom: "-22px",
  left: 0,
  width: "50%",
  textAlign: "left",
  padding: "5px",
  fontSize: "12px",
  color: "#555",
};

const rightLabelStyle = {
  ...labelStyle,
  left: "auto",
  right: 0,
  textAlign: "right",
};

// const myProgressStyle = {
//   display: "flex",
//   alignItems: "center",
//   gap: "3px",
//   marginTop: "8px",
//   width: "100%",
//   backgroundColor: "#eeeeee",

// };

// const myBarStyle = (count) => {
//   return {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     width: `${count}%`,
//     height: "30px",
//     backgroundColor: "#dc002d",
//     color: "white",
//   };
// };
